import News from '../components/pages/News/News';
export default News;
